module.exports = __webpack_public_path__ + "img/genba_btn2.c2784801.png";